module.exports = __webpack_public_path__ + "static/img/03.83c661a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/customPage/assets/borderImages/03.png
// module id = 60tP
// module chunks = 64